// prod
export default {
  depositAddress: '0x53895C703DBEd3891d189B0098bA0611F6140CD0',
  withdrawAddress: '0x2FB11841aB8969Adf8f921583005af0282C76fCF',
  tokenContractAddress: '0x340d2bde5eb28c1eed91b2f790723e3b160613b7',
  tokenDecimals: 18,
  server: 'https://api.bv.vatom.network',

  blockv: {
    chainId: '6300',
    chainName: 'BLOCKv Mainnet',
    server: 'https://api.bv.vatom.network/api/staking/bv',
    blockchainViewer: 'https://explorer.blockv.io/tx/{{transaction}}',
    rpcUrl: 'https://mainnet.rpc.blockv.network',
  },
  eth: {
    chainId: '1',
    chainName: 'Ethereum Mainnet',
    server: 'https://api.bv.vatom.network/api/staking/eth',
    blockchainViewer: 'https://etherscan.io/tx/{{transaction}}',
  },
};
